  document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('brands-list');
    if (!container) return;

    const scrollLinks = container.querySelectorAll('[data-scroll-to]');
    const brandSections = container.querySelectorAll('.brand-section');

    // Function to set the active link
    /**
     * @param {string | null} targetId
     */
    function setActiveLink(targetId) {
      scrollLinks.forEach((link) => {
        const isTarget = link.getAttribute('data-scroll-to') === targetId;
        const heading = link.querySelector('.brands-alphabet-link') || link;
        heading.classList.toggle('is-active', isTarget);
      });
    }

    // Click scroll handler
    scrollLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = link.getAttribute('data-scroll-to') || '';
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          setActiveLink(targetId);

          if (history.pushState) {
            history.pushState(null, '', `#${targetId}`);
          }
        }
      });
    });
  });